module.exports = __webpack_public_path__ + "static/media/pw.0961025d.svg";